import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'Home|News Articles|';
const sharedProps: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	feature: HubFeature.CandidateAccess,
	portal: 'CP',
	shared: false,
};

export type CPNewsArticlesLocNames =
	| 'CPNewsArticlesDate'
	| 'CPNewsArticlesHeadline'
	| 'CPNewsArticlesPageDescription'
	| 'CPNewsArticlesPageTitle';

export const cpNewsArticlesLocs: LocDefs<CPNewsArticlesLocNames> = {
	CPNewsArticlesDate: {
		defaultValue: 'Date',
		description: 'The text for the sort by date on the news article page.',
		displayPath: `${dpRoot}Date`,
		displayType: 'Label',
		htmlAllowed: false,
		...sharedProps,
	},
	CPNewsArticlesHeadline: {
		defaultValue: 'Headline',
		description: 'The text for the sort by headline on the news article page.',
		displayPath: `${dpRoot}Headline`,
		displayType: 'Label',
		htmlAllowed: false,
		...sharedProps,
	},
	CPNewsArticlesPageDescription: {
		defaultValue: '',
		description: 'The text for the page description on the news article page.',
		displayPath: `${dpRoot}Page Description`,
		displayType: 'Content',
		htmlAllowed: true,
		...sharedProps,
	},
	CPNewsArticlesPageTitle: {
		defaultValue: 'Announcements',
		description: 'The text for the page title on the news article page.',
		displayPath: `${dpRoot}Page Title`,
		displayType: 'Title',
		htmlAllowed: false,
		...sharedProps,
	},
};

export const LOC_KEYS = MapLocKeys<CPNewsArticlesLocNames>(cpNewsArticlesLocs);
